import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=87d70e50&scoped=true"
import script from "./login.js?vue&type=script&lang=js&external"
export * from "./login.js?vue&type=script&lang=js&external"
import style0 from "./login.scss?vue&type=style&index=0&id=87d70e50&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d70e50",
  null
  
)

export default component.exports